import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { CommonModule } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { getMatFormFieldPlaceholderConflictError, MatFormField } from '@angular/material/form-field';

@Component({
  selector: 'app-admin-add-device-type',
  templateUrl: './admin-add-device-type.component.html',
  styleUrls: ['./admin-add-device-type.component.scss'],
  standalone: true,
imports: [CommonModule,MatToolbar,MatFormField,ReactiveFormsModule]
})
export class AdminAddDeviceTypeComponent implements OnInit {
  private addDeviceType: any = BaseUrlConstantsService.ADD_DEVICE_TYPE;
  private editDeviceType: any = BaseUrlConstantsService.EDIT_DEVICETYPE_INFO;
  public pid: any;
  public showList: boolean;
  public emptyMsg: boolean;
  public pageRouteRef: string;
  public lastPageRef: any;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public uForm: any;
  public pageType: any;
  public pageTitle: string;
  public showSave = false;
  public showUpdate = true;
  public _deviceTypeId: any;
  public breadcrumbsArray: any = [{
    page_ref: 'view-device-type',
    page_title: 'device type'
  }, {
    page_ref: 'add-device-type',
    page_title: 'add device'
  }];

  constructor(
    public router: Router,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder) { }


  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  ngOnInit() {
    this.uForm = this.formBuilder.group({
      device_type: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
      device_detail: new FormControl('', [Validators.required, this.noWhitespaceValidator])
    });
    this.initialCallMethod();
    if (this._deviceTypeId != undefined) {
      this.getDeviceTypeInfo();
    }
  }

  async initialCallMethod() {
    this.activeRoute.queryParams.subscribe(params => {
      this.lastPageRef = params[`lastPageRef`];
      this._deviceTypeId = params[`deviceTypeId`];
      if (this.lastPageRef === 'view-device-type') {
        this.pageTitle = 'Add Device Type';
        this.breadcrumbsArray[1].page_title = 'Add Device Type';
        this.showSave = true;
        this.showUpdate = false;
      }
      if (params[`type`] !== undefined) {
        this.pageType = params[`type`];
        if (this.pageType === 'editBtnPress') {
          this.pageTitle = 'Edit Device Type';
          this.breadcrumbsArray[1].page_title = 'Edit Device Type';
          this.showSave = false;
          this.showUpdate = true;
        } else {
          this.pageTitle = 'Add Device Type';
          this.breadcrumbsArray[1].page_title = 'Add Device Type';
          this.showSave = true;
          this.showUpdate = false;
        }
      }
    });
  }

  async goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async addDevice() {
    this.router.navigate(['add-device-type']);
  }

  async saveDevice() {
    if (this.pageTitle == 'Add Device Type') {
      if (this.uForm.dirty && this.uForm.valid) {
        const body = {
          user_id: localStorage.getItem('user_id'),
          name: this.uForm.value.device_type,
          detail: this.uForm.value.device_detail
        };
        this.changeService.loader(true);
        this.service.addUserPost(this.addDeviceType, body).then(res => {
          this.changeService.loader(false);
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            this.service.showSuccess('Device registered successfully');
            this.router.navigate(['view-device-type']);
          } else {
            this.service.showError('Something went wrong.');
          }
        });
      }
    }
     else {
      const body = {
        name: this.uForm.value.device_type,
        detail: this.uForm.value.device_detail
      };
      this.changeService.loader(true);
      this.service.putData(this.editDeviceType + "/" + this._deviceTypeId, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.service.showSuccess('Device registered successfully');
          this.router.navigate(['view-device-type']);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }

  getDeviceTypeInfo() {
    console.log(this._deviceTypeId,"this._deviceTypeId")
    this.changeService.loader(true);
    this.service.getData(this.editDeviceType + "/" + this._deviceTypeId).then(response => {
      this.changeService.loader(false);
      var resp = JSON.parse(JSON.stringify(response)).data.body;
      if (JSON.parse(JSON.stringify(response)).data.status === 'success') {
        this.uForm = this.formBuilder.group({
          device_type: new FormControl(resp.name, [Validators.required, this.noWhitespaceValidator]),
          device_detail: new FormControl(resp.detail, [Validators.required, this.noWhitespaceValidator]),
        });
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }
}
